import React from 'react';

const SuccessView = ({ orderResult, setCart, setBuyNowItems, setView, setOrderResult }) => {
  const trackingId = orderResult?.trackingID || orderResult?.trackingId;
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6">
      <div className="max-w-xl w-full bg-white shadow-md rounded-2xl p-8 border border-gray-100 text-center space-y-4">
        <div className="mx-auto w-12 h-12 rounded-full bg-green-100 flex items-center justify-center text-green-600 text-2xl">✓</div>
        <h1 className="text-2xl font-bold text-gray-900">Commande enregistrée !</h1>
        <p className="text-gray-600">Merci ! Votre demande a été prise en compte.</p>
        {trackingId && (
          <div className="p-4 rounded-xl bg-gray-50 border border-gray-100">
            <p className="text-sm text-gray-500">Tracking ID</p>
            <p className="text-lg font-semibold text-gray-900">{trackingId}</p>
          </div>
        )}
        {trackingId && (
          <a
            href={`/tracking?tracking-id=${trackingId}&submit=1`}
            className="inline-flex items-center justify-center px-4 py-3 rounded-lg app-btn text-white font-semibold"
          >
            Suivre ma commande
          </a>
        )}
        <button
          onClick={() => { setCart([]); setBuyNowItems(null); setView('catalogue'); setOrderResult(null); }}
          className="block w-full text-sm text-gray-500 hover:text-gray-700 pt-2"
        >
          Retour au catalogue
        </button>
      </div>
    </div>
  );
};

export default SuccessView;
